import firebase from './config';
import db from './dbConfig'

const increment = firebase.firestore.FieldValue.increment(1)

function criarFicha(uid, inputData, groupName, dataSaved) {

   db.collection('fichas').add({
    ...inputData,
    asa: Number(inputData.asa) || null,
    idade: inputData.idade || null,
    nome: inputData.nome.toUpperCase(),
    dateInSeconds: Date.parse(inputData.data)/1000,
    orcamento: "",
    groupName: groupName || null,
    user: uid,
  })
  .then(function(docRef) {
    dataSaved()
    db.collection('users').doc(uid).set({
      recordsCount: increment,
    },{merge: true})
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

function atualizarFicha(id, data, dataSaved) {
  return db.collection('fichas').doc(id).update({
    ...data,
    asa: Number(data.asa) || null,
    idade: data.idade || null,
    nome: data.nome.toUpperCase(),
    dateInSeconds: Date.parse(data.data)/1000,

  })
  .then(function() {
      dataSaved()
  })
  .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}

function apagarFicha(id) {
  db.collection('fichas').doc(id).delete()
  .then(function() {
    window.location.reload(false)
  })
  .catch(function(error) {
    console.error("Error removing document: ", error);
});
}

function criarTabela(uid, data) {
  db.collection('users').doc(uid).collection("tabelasCadastradas").doc(data.nomeTabela).set({
    nomeTabela: data.nomeTabela,
    0: Number(data.porte0),
    1: Number(data.porte1),
    2: Number(data.porte2),
    3: Number(data.porte3),
    4: Number(data.porte4),
    5: Number(data.porte5),
    6: Number(data.porte6),
    7: Number(data.porte7),
    8: Number(data.porte8),
  })
  .then(function() {
    console.log("Document written");
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

function apagarTabela(uid, id) {
  db.collection('users').doc(uid).collection("tabelasCadastradas").doc(id).delete()
  .then(function() {
    console.log("Tabela Apagada")
  })
  .catch(function(error) {
    console.error("Error removing document: ", error);
});
}

function atualizarOrcamento(id, data) {
  return db.collection('fichas').doc(id).update({
    orcamento: data,
  })
  .then(function() {
    console.log("Document successfully updated!");
  })
  .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}

function atualizarApfel(id, data) {
  return db.collection('fichas').doc(id).update({
    apfel: data,
  })
  .then(function() {
    console.log("Document successfully updated!");
  })
  .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}
function atualizarLee(id, data) {
  return db.collection('fichas').doc(id).update({
    lee: data,
  })
  .then(function() {
    console.log("Document successfully updated!");
  })
  .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}
function atualizarEmapo(id, data) {
  return db.collection('fichas').doc(id).update({
    emapo: data,
  })
  .then(function() {
    console.log("Document successfully updated!");
  })
  .catch(function(error) {
    // The document probably doesn't exist.
    console.error("Error updating document: ", error);
  });
}

function atualizarPerfil(uid, data) {
  db.collection('users').doc(uid).set({
    profile: {...data,
              date: new Date(),
              prevUpdated: true}
}, { merge: true })
  .then(function() {
    console.log("Document written");
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

function atualizarOpcoes(uid, data) {
  db.collection('users').doc(uid).set({
    options: data
}, { merge: true })
  .then(function() {
    console.log("Document written");
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

function atualizarGrupo(uid, data) {
  db.collection('users').doc(uid).set({
    groupName: data
}, { merge: true })
  .then(function() {
    console.log("Document written");
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

function enviarMsg(data) {
  db.collection("suporte").add({
    data
  })
  .then(function(docRef) {
    console.log("Mensagem enviada ao Suporte")
  })
  .catch(function(error) {
    console.error("Error adding document: ", error);
  });
}

export { criarFicha, atualizarFicha, apagarFicha, criarTabela, apagarTabela,
  atualizarOrcamento, atualizarPerfil, atualizarOpcoes, atualizarGrupo, enviarMsg,
  atualizarApfel, atualizarLee, atualizarEmapo }
